//RealTime
export const TOURNOI_COLLECTION_NAME = 'tournois';

//Firestore
export const CHAMPIONNATS_COLLECTION_NAME = 'championnats';
export const PLAYERS_COLLECTION_NAME = 'players';
export const OUTILS_COLLECTION_NAME = 'outils';
export const RANGES_COLLECTION_NAME = 'ranges';
export const TOURNOI_IMPORTED_COLLECTION_NAME = 'tournoiImported';
